import {
  isTokenSuspiciousCheck,
  suspiciousCheckData,
} from '../../Wallets/labels';
import moment from 'moment';
import { ColumnsProps } from '../columns';

export default function LaunchColumn({ data, tokenStats }: ColumnsProps) {
  return (
    <div
      className={
        isTokenSuspiciousCheck(suspiciousCheckData(tokenStats, data))
          ? 'xxs:text-dex-white-secondary'
          : ''
      }
    >
      {data.poolCreatedAt ? (
        <div className="xxs:text-xs">
          {moment(data.poolCreatedAt).format('DD/MM/YYYY HH:mm')}
        </div>
      ) : (
        <div className="text-xs">--</div>
      )}
    </div>
  );
}
